module.exports = __webpack_public_path__ + "mv.svg?c11e6efecc84326132b226b7cf84bea5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mv.svg
// module id = 1263
// module chunks = 0